export default __webpack_public_path__ + "static/media/b-2.e990b91f.svg";